import { Divider, Menu, MenuItem } from "@mui/material";
import { styled } from "styled-components";

interface IProps {
  anchor: any;
  onClose: () => any;
  onAddRule: (position: number) => any;
  onDeleteRule: () => any;
}

const StyledMenuItem = styled(MenuItem)`
  font-family: "Roboto", sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 24px;
  color: #252525;
`;

const StyledRedMenuItem = styled(StyledMenuItem)`
  color: #e2221b;
`;

export const RuleMenu = ({ anchor, onClose, onAddRule, onDeleteRule }: IProps) => {
  return (
    <Menu
      anchorEl={anchor}
      id="rule-menu"
      open={Boolean(anchor)}
      onClose={onClose}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
    >
      <StyledMenuItem onClick={() => onAddRule(0)}>Add row above</StyledMenuItem>
      <StyledMenuItem onClick={() => onAddRule(1)}>Add row below</StyledMenuItem>
      <Divider />
      <StyledRedMenuItem onClick={() => onDeleteRule()}>Delete</StyledRedMenuItem>
    </Menu>
  );
};
